import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const auth = useSelector((state) => state.auth);

  const location = useLocation(); // Get the current location

  const isActive = (path) => location.pathname === path;
  return (
    <>
      <div className="sidebar" id="sidebar">
        <div className="sidebar-inner slimscroll" style={{ overflowY: "auto" }}>
          <div id="sidebar-menu" className="sidebar-menu">
            {auth && auth.user && auth.user.role === "superAdmin" && (
              <>
                <ul>
                  <li className="menu-title">
                    <span>Main</span>
                  </li>
                  <li className={isActive("/dashboard") ? "active" : ""}>
                    <Link to="/dashboard">
                      <i className="fa fa-home"></i> <span>Dashboard</span>
                    </Link>
                  </li>
                  <li className={isActive("/cities") ? "active" : ""}>
                    <Link to="/cities">
                      <i className="fa-solid fa fa-location-dot"></i>
                      <span>Cities</span>
                    </Link>
                  </li>
                  <li className={isActive("/shops") ? "active" : ""}>
                    <Link to="/shops">
                      <i className="fa fa-landmark"></i> <span>Shops</span>
                    </Link>
                  </li>
                  <li className={isActive("/customers") ? "active" : ""}>
                    <Link to="/customers">
                      <i className="fa fa-users"></i> <span>Customers</span>
                    </Link>
                  </li>
                  <li className={isActive("/drivers") ? "active" : ""}>
                    <Link to="/drivers">
                      <i className="fa fa-truck"></i> <span>Drivers</span>
                    </Link>
                  </li>
                  <li className={isActive("/orders") ? "active" : ""}>
                    <Link to="/orders">
                      <i className="fa fa-shopping-cart"></i> <span>Order</span>
                    </Link>
                  </li>
                  <li className={isActive("/categories") ? "active" : ""}>
                    <Link to="/categories">
                      <i className="fa fa-table-cells"></i>{" "}
                      <span>Categories</span>
                    </Link>
                  </li>
                  <li className={isActive("/subcategories") ? "active" : ""}>
                    <Link to="/subcategories">
                      <i className="fa fa-align-center"></i>{" "}
                      <span>Sub Categories</span>
                    </Link>
                  </li>
                  <li className={isActive("/products") ? "active" : ""}>
                    <Link to="/products">
                      <i className="fa fa-box"></i> <span>Products</span>
                    </Link>
                  </li>
                  <li className={isActive("/all-payments") ? "active" : ""}>
                    <Link to="/all-payments">
                      <i className="fa fa-credit-card"></i>{" "}
                      <span>Payments</span>
                    </Link>
                  </li>
                  <li className={isActive("/referral") ? "active" : ""}>
                    <Link to="/referral">
                      <i className="fa fa-smile"></i> <span>Referral</span>
                    </Link>
                  </li>
                  <li className="menu-title">
                    <span>Manage</span>
                  </li>
                  <li className={isActive("/languages") ? "active" : ""}>
                    <Link to="/languages">
                      <i className="fa fa-globe"></i> <span>Languages</span>
                    </Link>
                  </li>
                  <li className={isActive("/contact-forms") ? "active" : ""}>
                    <Link to="/contact-forms">
                      <i className="fa fa-envelope"></i>{" "}
                      <span>Contact Forms</span>
                    </Link>
                  </li>
                  <li className={isActive("/store-request") ? "active" : ""}>
                    <Link to="/store-request">
                      <i className="fa fa-share"></i> <span>Store Request</span>
                    </Link>
                  </li>
                  <li className={isActive("/driver-request") ? "active" : ""}>
                    <Link to="/driver-request">
                      <i className="fa fa-bicycle"></i>{" "}
                      <span>Driver Request</span>
                    </Link>
                  </li>
                  <li className={isActive("/banners") ? "active" : ""}>
                    <Link to="/banners">
                      <i className="fa fa-rectangle-list"></i>{" "}
                      <span>Banners</span>
                    </Link>
                  </li>
                  <li className={isActive("/offers") ? "active" : ""}>
                    <Link to="/offers">
                      <i className="fa fa-shopping-bag"></i> <span>Offers</span>
                    </Link>
                  </li>
                  <li className={isActive("/notifications") ? "active" : ""}>
                    <Link to="/notifications">
                      <i className="fa fa-bell"></i> <span>Notifications</span>
                    </Link>
                  </li>
                  <li className={isActive("/send-mail") ? "active" : ""}>
                    <Link to="/send-mail" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-paper-plane"></i>{" "}
                      <span>Send Mail</span>
                    </Link>
                  </li>
                  <li className={isActive("/support") ? "active" : ""}>
                    <Link to="/support" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-comment"></i> <span>Support</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/stats" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-chart-line"></i> <span>Stats</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/complaints" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-balance-scale"></i>{" "}
                      <span>Complaints</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/general" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-info"></i> <span>General</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/settings" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-gear"></i> <span>Settings</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/pages" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-file"></i> <span>Pages</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/manage-app" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-mobile-screen-button"></i>{" "}
                      <span>Manage App</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/manage-popup" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-desktop"></i>{" "}
                      <span>Manage Popup</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/app-updates" style={{ cursor: "not-allowed" }}>
                      <i className="fa fa-save"></i> <span>App Updates</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/administrator">
                      <i className="fa fa-shield"></i>{" "}
                      <span>Administrator</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/address">
                      <i className="fa fa-location-arrow"></i>{" "}
                      <span>Address</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/buy-now">
                      <i className="fa fa-paperclip"></i> <span>Buy Now</span>
                    </Link>
                  </li>
                </ul>
              </>
            )}
            {auth && auth.user && auth.user.role === "admin" && (
              <>
                <ul>
                  <li className="menu-title">
                    <span>Main</span>
                  </li>
                  <li className={isActive("/dashboard") ? "active" : ""}>
                    <Link to="/dashboard">
                      <i className="fa fa-home"></i> <span>Dashboard</span>
                    </Link>
                  </li>
                  <li className={isActive("/orders") ? "active" : ""}>
                    <Link to="/orders">
                      <i className="fa fa-shopping-cart"></i> <span>Order</span>
                    </Link>
                  </li>
                  <li className={isActive("/analytics") ? "active" : ""}>
                    <Link
                      // to="/analytics"
                      style={{ cursor: "not-allowed" }}
                    >
                      <i className="fa fa-bar-chart"></i> <span>Analytics</span>
                    </Link>
                  </li>
                  <li className={isActive("/products") ? "active" : ""}>
                    <Link to="/products">
                      <i className="fa fa-box"></i> <span>Products</span>
                    </Link>
                  </li>
                  <li className={isActive("/reviews") ? "active" : ""}>
                    <Link to="/reviews">
                      <i className="fa fa-smile"></i> <span>Reviews</span>
                    </Link>
                  </li>
                  <li className={isActive("/support") ? "active" : ""}>
                    <Link
                      // to="/support"
                      style={{ cursor: "not-allowed" }}
                    >
                      <i className="fa fa-comment"></i> <span>Support</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      // to="/stats"
                      style={{ cursor: "not-allowed" }}
                    >
                      <i className="fa fa-chart-line"></i> <span>Stats</span>
                    </Link>
                  </li>
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Sidebar;
